<template>
  <div class="ser-1">
    <div class="record-1">
      <div class="record-2">
        <div>
          <el-button type="primary">刷新</el-button>
        </div>
        <div>
          <el-button type="primary" @click="detailsRecord">查看工单</el-button>
        </div>
        <div>
          <el-button type="primary">发送短信</el-button>
        </div>
        <div>
          <el-button type="primary">催单</el-button>
        </div>
      </div>
      <div>
        <el-button type="danger">废除工单</el-button>
      </div>
    </div>

    <div class="record-3">
      <el-table
        :data="tableData"
        @selection-change="handleSelectionChange"
        border
        style="width: 80%"
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column
          type="index"
          width="70"
          label="序号"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="projectName"
          label="工单号"
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="projectContent"
          label="工单状态"
          align="center"
          width="120"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="adress"
          label="服务地址"
          align="center"
          width="220"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="riqi"
          label="服务日期"
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="project"
          label="服务项目"
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="project"
          label="服务内容"
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="project"
          label="服务人员 "
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="project"
          label="服务人员电话 "
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="project"
          label="催单次 "
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="bottom-page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="查看"
      :visible.sync="dialogVisible"
      width="40%"
      append-to-body
      class="dialog_container"
    >
      <div class="dia-1">
        <div>
          <div class="dia-2">
            <div>工单号</div>
            <div>
              <el-input size="small"></el-input>
            </div>
          </div>
          <div class="dia-2">
            <div>用户服务</div>
            <div>
              <el-input size="small"></el-input>
            </div>
          </div>
          <div class="dia-2">
            <div>用户电话</div>
            <div>
              <el-input size="small"></el-input>
            </div>
          </div>
          <div class="dia-2">
            <div>用户档案号</div>
            <div>
              <el-input size="small"></el-input>
            </div>
          </div>
          <div class="dia-2">
            <div>机械编号</div>
            <div>
              <el-input size="small"></el-input>
            </div>
          </div>
          <div class="dia-2">
            <div>服务地址</div>
            <div>
              <el-input size="small"></el-input>
            </div>
          </div>
          <div class="dia-2">
            <div>服务区域</div>
            <div>
              <el-input size="small"></el-input>
            </div>
          </div>
          <div class="dia-2">
            <div>服务日期</div>
            <div>
              <el-input size="small"></el-input>
            </div>
          </div>
          <div class="dia-2">
            <div>服务项目</div>
            <div>
              <el-input size="small"></el-input>
            </div>
          </div>
          <div class="dia-2">
            <div>服务内容</div>
            <div>
              <el-input type="textarea" :rows="2"></el-input>
            </div>
          </div>
          <div class="dia-2">
            <div>服务启始时间</div>
            <div>
              <el-input size="small"></el-input>
            </div>
          </div>
          <div class="dia-2">
            <div>预计完成时间</div>
            <div>
              <el-input size="small"></el-input>
            </div>
          </div>
          <div class="dia-2">
            <div>实际启始时间</div>
            <div>
              <el-input size="small"></el-input>
            </div>
          </div>
          <div class="dia-2">
            <div>实际完成时间</div>
            <div>
              <el-input size="small"></el-input>
            </div>
          </div>
          <div class="dia-2">
            <div>机构</div>
            <div>
              <el-input size="small"></el-input>
            </div>
          </div>
          <div class="dia-2">
            <div>服务员电话</div>
            <div>
              <el-input size="small"></el-input>
            </div>
          </div>
          <div class="dia-2">
            <div>完成情况</div>
            <div>
              <el-input type="textarea" :rows="2"></el-input>
            </div>
          </div>
          <div class="dia-2">
            <div>满意度</div>
            <div>
              <el-input size="small"></el-input>
            </div>
          </div>
          <div class="dia-2">
            <div>回访情况</div>
            <div>
              <el-input type="textarea" :rows="2"></el-input>
            </div>
          </div>
        </div>
        <div class="dia-4">
          <div class="block">
            <el-timeline>
              <el-timeline-item
                v-for="(activity, index) in activities"
                :key="index"
                icon="el-icon-more"
                type="primary"
                color="red"
                size="normal"
              >
                <div class="server-1">
                  <p>{{ activity.content }}</p>
                  <p class="server-2">
                    {{ activity.name1 }}:{{ activity.name2 }}
                  </p>
                  <p class="server-2">
                    {{ activity.name3 }}:{{ activity.name4 }}
                  </p>
                  <p class="server-2">状态：{{ activity.name5 }}</p>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      query: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 1,
      activities: [
        //   {
        // 	content: '坐席下单',
        // 	name1:'下单人',
        // 	name2:'啊啊',
        // 	name3:'下单时间',
        // 	name4:'2020-12-12',
        // 	name5:'已下单'
        // }, {
        // 	content: '总部派单',
        // 	name1:'办理人',
        // 	name2:'啊啊',
        // 	name3:'办理时间',
        // 	name4:'2020-12-12',
        // 	name5:'已下单'
        // }, {
        // 	content: '机构派单',
        // 	name1:'办理人',
        // 	name2:'啊啊',
        // 	name3:'办理时间',
        // 	name4:'2020-12-12',
        // 	name5:'已下单'
        // }, {
        // 	content: '上门签入',
        // 	name1:'办理人',
        // 	name2:'啊啊',
        // 	name3:'办理时间',
        // 	name4:'2020-12-12',
        // 	name5:'已下单'
        // },
        // {
        // 	content: '上门签出',
        // 	name1:'办理人',
        // 	name2:'啊啊',
        // 	name3:'办理时间',
        // 	name4:'2020-12-12',
        // 	name5:'已下单'
        // },
        // {
        // 	content: '待回访',
        // 	name1:'办理人',
        // 	name2:'啊啊',
        // 	name3:'办理时间',
        // 	name4:'2020-12-12',
        // 	name5:'已下单'
        // }
      ],
      tableData: [
        //   {
        // 	projectName: 'DFF34151',
        // 	projectContent: '已结单',
        // 	adress: '惠民园16栋204室定位图标',
        // 	riqi: '2020-12-12',
        // 	project: '政府助洁套餐政府助洁套餐'
        // }
      ],
      dialogVisible: false,
    }
  },
  methods: {
    handleSelectionChange(val) {},
    handleSizeChange(val) {},
    handleCurrentChange(val) {},
    detailsRecord() {
      this.dialogVisible = true
    },
  },
}
</script>

<style lang="less" scoped>
.ser-1 {
  width: 98%;
  margin-left: 2%;
  position: absolute;
}

.record-1 {
  width: 80%;
  display: flex;
  justify-content: space-between;
}

.record-2 {
  display: flex;
}

.record-2 > div {
  margin-right: 20px;
}

.record-3 {
  width: 100%;
  margin: 20px 0;
  position: relative;
}

.dialog_container {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #e5e5e5;
  }
}

.dia-1 {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.dia-1 > div {
  width: 48%;
}

.dia-2 {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.dia-2 > div:first-child {
  width: 100px;
  text-align: center;
}
.dia-4 {
  background-color: #f2f2f2;
}
.server-1 {
  width: 220px;
  height: 120px;
  border-radius: 10px;
  background-color: #ffffff;
}
.server-1 > p:first-child {
  width: 100%;
  text-align: center;
  height: 40px;
  line-height: 40px;
  background-color: red;
  color: #ffffff;
  border-radius: 10px 10px 0 0;
}
.server-2 {
  width: 90%;
  margin-left: 10%;
  margin-top: 5px;
}
</style>
